import { FastConditionalStrategy } from 'utility-ts-strategy';
import { IApplicationConfiguration } from '../../../interfaces/scheduler_interfaces';
import { PlannerConstants } from '../constants/planner_constants';
import { INotificationDelegate } from '../../../global/helpers/scheduler_notification_delegate';

export class BackToPlannerHelper {
  constructor(
    private $state: ng.ui.IStateService,
    private appConfigModel: IApplicationConfiguration,
    private ngSchedulerNotificationDelegate: INotificationDelegate
  ) {}

  navigateToAP3Planner() {
    window.location.assign('#/my/ap3/student');
  }

  navigateToAP1Planner() {
    this.$state.go('my.planner.default', {}, { reload: 'my.planner.default' });
  }

  isAP3PlannerEnabled() {
    return this.appConfigModel.isFeatureEnabled(PlannerConstants.AP3_FT);
  }

  isAP1PlannerEnabled() {
    return this.appConfigModel.isFeatureEnabled(PlannerConstants.AP1_FT);
  }

  isPlannerDisabled() {
    return !this.isAP3PlannerEnabled() && !this.isAP1PlannerEnabled();
  }

  navigateToPlanner() {
    return new FastConditionalStrategy([
      [() => this.navigateToAP3Planner(), () => this.isAP3PlannerEnabled()],
      [() => this.navigateToAP1Planner(), () => this.isAP1PlannerEnabled()],
      [
        () => this.ngSchedulerNotificationDelegate.info('Sorry, Planner disabled/not available'),
        () => this.isPlannerDisabled()
      ]
    ]).evaluate(this, this.isPlannerDisabled)();
  }
}

angular.module('capability-ng-scheduler').service('ngBackToPlannerHelper', BackToPlannerHelper);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/back_to_planner/helpers/back_to_planner_helper.ts